<template>
  <FinanceLayout>
    <router-view />
  </FinanceLayout>
</template>

<script>
import FinanceLayout from '@/layouts/FinanceLayout.vue';

export default {
    components: {
        FinanceLayout
    }
}
</script>

<style scoped></style>